import { render, staticRenderFns } from "./IconChevronUpWithCircle.vue?vue&type=template&id=0a486d6a&"
import script from "./IconChevronUpWithCircle.vue?vue&type=script&setup=true&lang=ts&"
export * from "./IconChevronUpWithCircle.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports